/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HashValue = {
    type: 'string',
} as const;
